import React, { Component } from 'react';
import LoaderSection from '../components/loader-section.jsx';
import toast from '../../components/toast';
import { addProduct, deleteProduct, getCartCount, getCurrentQty } from '../../apis/shopping-cart';

class ShoppingCartLanding extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            quantity: 1,
            sku: props.sku,
            itemNum: props.itemNum,
            isInCart: props.inCart === 'False' ? false : true,
            isInStock: props.isInStock === 'False' ? false : true,
            inventory: 0,
            authenticated: props.authenticated === 'False' ? false : true
    };

        this.handleDelete = this.handleDelete.bind(this);
        this.handleQuantity = this.handleQuantity.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleQuantity(e) {
        e.preventDefault();
        let target = e.target;
        let quantity;
        if (target.classList.contains('input-arrow-top')) quantity = this.state.quantity + 1;
        if (target.classList.contains('input-arrow-btm')) quantity = this.state.quantity - 1;

        this.setState({
            quantity: quantity
        });
    }

    handleAdd(e) {
        e.preventDefault();

        getCurrentQty(this.state.itemNum)
            .then(json => {
                if (this.state.quantity > json) {
                    toast.error('Order is over inventory amount');
                } else if (this.state.quantity < 1) {
                    toast.error('Please add at least one item to your quantity');
                } else {
                    this.addProduct();
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    addProduct() {
        if (this.state.authenticated) {
            addProduct(this.state.sku, this.state.quantity)
                .then(data => {
                    console.log(data);
                    if (data) {
                        toast.success('Item added to shopping cart');
                        this.updateNumbers();
                        this.setState({
                            isInCart: true
                        });
                    } else {
                        toast.error('There was an issue adding your product');
                    }
                })
                .catch(error => {
                    console.log(error);
                    toast.error('There was an issue adding your product');
                });
        } else {
            toast.error('Please login to add products to your cart');
        }
    }

    handleDelete(e) {
        e.preventDefault();

        deleteProduct(this.state.sku, true)
            .then(data => {
                if (data) {
                    console.log(data);
                    toast.success('Item removed from shopping cart');
                    this.updateNumbers();
                    this.setState({
                        isInCart: false
                    });
                } else {
                    toast.error('There was an issue removing your product');
                }
            })
            .catch(error => {
                console.log(error);
                toast.error('There was an issue removing your product');
            });
    }

    updateNumbers() {
        const number = document.querySelector('.js-cart-number');

        getCartCount()
            .then(data => {
                number.innerHTML = data;
            })
            .catch(error => {
                console.log(error);
            });
    }


    render() {
        let actions;

        if (!this.state.isInCart) {
            actions =
                <div className="row cart-options">
                    <div className="btn btn-outline-alt" onClick={this.handleAdd}>Add To Cart</div>
                    <div className="actions-container on-product">
                        <div className="cart-quantity-container on-product new-item">

                            <div className="cart-input-container">
                                <input name="quantity" type="number" pattern="[0-9]" className="on-product form-control form-input-number cart-quantity-input js-cart-quantity-input" value={
                                    this.state.quantity} onChange={this.handleChange}/>
                                <div className="input-arrows on-product">
                                    <div className="input-arrow input-arrow-top" onClick={this.handleQuantity}></div>
                                    <div className="input-arrow input-arrow-btm" onClick={this.handleQuantity}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>;
        }
        if (this.state.isInCart) {
            actions =
                <div className="in-cart-actions">
                    <button class="btn no-arrow left-padding-20 added-to-cart">
                        <svg class="icon icon-check-mark"><use xlinkHref="#icon-check-mark"></use></svg>
                        <span>Added To Cart</span>
                    </button>
                    <p className="cart-remove-product" onClick={this.handleDelete}>Remove From Cart</p>

                </div>
        }

        if (!this.state.isInStock) {
            actions =
                <div>
                    <button className="btn left-padding-20 no-arrow out-of-stock" disabled>Out Of Stock</button>
                </div>;
        }

        if (this.state.isLoading) {
            actions = <LoaderSection show={true} />;
        }

        return (
            <div>
                {actions}
            </div>
        );
    }
}

export default ShoppingCartLanding;